<template>
	<div>
		<div style="margin-bottom:20px;">
			<h1 style="text-align:left;">联系我们管理</h1>
			<el-divider></el-divider>
		</div>
		<div>
      <div>
        <el-button type="text" @click="dialogFormVisible = true">添加</el-button>
        <el-dialog title="添加" :visible.sync="dialogFormVisible" :open="close">
          <el-form :model="form">
            <el-form-item label="标题">
              <el-input v-model="form.info.title" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="iconname">
              <el-input v-model="form.info.iconname" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="内容">
              <el-input v-model="form.info.content" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false;">取 消</el-button>
            <el-button type="primary" @click="addCarouse">提 交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
		<el-dialog title="修改联系我们" :visible.sync="modify_dialog" :open="close">
      <el-form :model="form">
        <el-form-item label="标题">
          <el-input v-model="form.info.title" autocomplete="off"></el-input>
        </el-form-item>
				<el-form-item label="iconname">
					<el-input v-model="form.info.iconname" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="内容">
          <el-input v-model="form.info.content" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modify_dialog = false;file_list = [];">取 消</el-button>
        <el-button type="primary" @click="confirmModifyCarouse">修 改</el-button>
      </div>
    </el-dialog>
		<el-table :data="tableData" style="width: 100%" stripe>
      <el-table-column label="id" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="标题" width="180">
        <template slot-scope="scope">{{scope.row.info.title}}</template>
      </el-table-column>
			<el-table-column label="iconname" width="180">
        <template slot-scope="scope">{{scope.row.info.iconname}}</template>
      </el-table-column>
      <el-table-column label="内容" width="280">
        <template slot-scope="scope">{{scope.row.info.content}}</template>
      </el-table-column>
      
      <el-table-column label="操作"> 
				<template slot-scope="scope">
					<el-button size="mini" @click="modify_carouse(scope.row)">编辑</el-button>
					<el-button
					size="mini"
					type="danger"
					@click="handleDelete(scope.$index, scope.row,tableData)"
					>删除</el-button>
				</template>   
      </el-table-column>
    </el-table>
	</div>
</template>

<style scoped>

</style>

<script>
export default {
	name: 'phone_manage',
	data() {
		return {
			modify_dialog: false,
			dialogFormVisible: false,
			form: {
				info: {
					title: null,
					iconname: null,
					content: null
				}	 
			},
			tableData: [{
				id: "1",
				info: {
					title: '公司地址',
					iconname: 'fa-map-marker',
					content: '广东省广州市海珠区江南大道中路80号 创展自由港大厦 1309室'
				}
			}]
		}
	},
	methods: {
		modify_carouse(row) {  
			this.modify_dialog = true;
			this.form = row
		},
		close() {
      console.log("关闭");
			this.form.info.title = null;
			this.form.info.icon = null;
			this.form.info.content = null;
		},
		confirmModifyCarouse() {
			var self = this;
      this.form.info = JSON.stringify(this.form.info);
      this.ajax("/phonemanage.php", "patch", JSON.stringify(this.form), function(data) {
        self.modify_dialog = false;
        self.ajax("/phonemanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
        });
        self.$message({
          message: "修改成功",
          type: "success"
        });
      });
		},
		addCarouse() {
			var self = this;
      var subdata = self.form.info;
			this.ajax("/phonemanage.php", "post", JSON.stringify(subdata), function(data) {
        self.dialogFormVisible = false;
        self.form.info.title = null;
        self.form.info.iconname = null;
        self.form.info.content = null;
        self.ajax("/phonemanage.php", "get", null, function(data) {
					var tableData = JSON.parse(data);
					for(let i=0;i<tableData.length;i++){
						tableData[i].info = JSON.parse(tableData[i].info);
					}
					self.tableData = tableData;
        });
        self.$message({
          message: "添加成功",
          type: "success"
        });
      });
		},
		handleDelete(index, row, rows) {
      var self = this;
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.ajax("/phonemanage.php?id=" + row.id, "delete", null, function(data) {
            rows.splice(index, 1);
            self.$message({
              message: "删除成功",
              type: "success"
            });
          });
        })
        .catch(() => {});
    },
	},
	mounted() {
    var self = this;
    this.ajax("/phonemanage.php", "get", null, function(data) {
			var tableData = JSON.parse(data);
			for(let i=0;i<tableData.length;i++){
				tableData[i].info = JSON.parse(tableData[i].info);
			}
			self.tableData = tableData;
    });
  }
}
</script>


// WEBPACK FOOTER //
// src/components/phone_manage.vue